<div>
  <div class="horizontal-alignment">
    <i-feather [attr.aria-hidden]="true" [name]="icons.NoDate" class="dx-button-has-icon btn-icon"></i-feather>
  </div>
  <div class="horizontal-alignment" [attr.aria-label]="'no_data' | translate">{{ 'no_data' | translate }}</div>
</div>
